import { onDomReady } from "../services/on-dom-ready";
import ModalBlocked from "../components/modal/modal-blocked";
import { apiFetch } from "./api-fetch";
import AjaxForm from "../components/ajax-form";
import Toast from "../components/modal/toast";

let initCompainPopup = popup => {
  let form = popup.root.querySelector('form');

  new AjaxForm(form, {
    afterSubmit: () => {
      popup.close();
      form.reset();
    },
    onNetworkError: () => {
      Toast.open("Не удалось отправить жалобу", { state: "error" });
    } 
  });

  return {
    open: () => popup.open(),
    update: (type, id) => {
      popup.root.setAttribute('data-type', type);
      form.elements['complainType'].value = type;
      form.elements['complainId'].value = id;
    }
  }
}

let complainPromise = new Promise((resolve, reject) => {
  onDomReady.then(() => {
      let element = document.getElementById("complain-popup");
      if (element) {
        let popup = ModalBlocked.get(element);

        popup = initCompainPopup(popup);
        resolve(popup);
      } else {
        reject("There is no #complain-popup element on page");
      }
    });
});

const complain = (type, id) => {
  complainPromise.then(popup => {
    popup.update(type, id);
    popup.open();
  });
};

export { complain };